import { WheelAction, WheelSegment, WheelBonusReward, WheelButtonConfig, WheelGenericResponse, WheelPrize, WheelProductReward, WheelSpinReward } from "../models/wheel-of-fortune.model";


export const wheelTextClassMaker = (type:'header'|'description'|'subtitles') => {
    switch (type) {
        case 'header':
            return ['clr-accent', 'fsz-lg', 'fw-bold', 'transform-uppercase'];
        case 'description':
            return ['clr-primary', 'fsz-md'];
        case 'subtitles':
            return ['clr-primary', 'fsz-md'];
        default:
            return [];
    }
}

export const wheelButtonTextClassMaker = (type: 'primary' | 'secondary') => {
    switch (type) {
        case 'primary':
            return ['clr-white', 'fw-bold']
        case 'secondary':
            return ['clr-primary', 'fw-bold']
    }
}

export const wheelHeaders = {
    default: () => ({ text: 'WHEEL.HEADER.DEFAULT', translateKeyValuePairs: {}, classes: wheelTextClassMaker('header') }),
    spinMarket: (bonuses:number) => ({text: 'WHEEL.HEADER.SPIN_MARKET', translateKeyValuePairs: { bonuses }, classes: wheelTextClassMaker('header') }),
    afterOrder: () => ({ text: 'WHEEL.HEADER.AFTER_ORDER', translateKeyValuePairs: {}, classes: wheelTextClassMaker('header') }),
    outOfSpins: () =>  ({text: 'WHEEL.HEADER.OUT_OF_SPINS', translateKeyValuePairs: {},classes: wheelTextClassMaker('header') })
}

export const wheelDescriptions = { 
    default: (minOrder: number, spins: number, days: number, registration_days:number, registration_spins:number) => ({
        html: 'WHEEL.DESCRIPTION.DEFAULT',
        translateKeyValuePairs: {
        minOrder,
        spins,
        days,
        registration_days,
        registration_spins
    }, classes:wheelTextClassMaker('description') }),
    profile_out_of_spins: (minOrder: number, spins: number, days: number, registration_days:number, registration_spins:number) => ({
        html: 'WHEEL.DESCRIPTION.INSTRUCTION_GET_SPINS',
        translateKeyValuePairs: {
        minOrder,
        spins,
        days,
        registration_days,
        registration_spins
    }, classes:wheelTextClassMaker('description') })
}

export const wheelSubtitles = {
    default: (spins: number) => ({
        html: 'WHEEL.SUBTITLE.DEFAULT',
        translateKeyValuePairs: {
            spins
        },
        classes: wheelTextClassMaker('subtitles')
    })
}

export const wheelButtons = {
    authorize: () => ({
        action: WheelAction.AUTHORIZE,
        translateKeyValuePairs: {},
        classes: wheelButtonTextClassMaker('secondary'),
    } as WheelButtonConfig),
    orderForSpins: (spins: number) => ({
        action: WheelAction.ORDER,
        text: 'WHEEL.BUTTONS.ORDER_TO_GET_SPINS',
        translateKeyValuePairs: { spins },
        classes: wheelButtonTextClassMaker('primary'),
        type: 'primary'
    }as WheelButtonConfig),
    exchangeBonusesForSpins: () => ({
        action: WheelAction.BUY_SPINS,
        text: 'WHEEL.BUTTONS.BUY_SPINS',
        translateKeyValuePairs: {  },
        classes: wheelButtonTextClassMaker('secondary'),
        type: 'secondary'
    } as WheelButtonConfig),
    spin: () => ({
        action: WheelAction.SPIN,
        text: 'WHEEL.BUTTONS.SPIN',
        translateKeyValuePairs: {  },
        classes: wheelButtonTextClassMaker('primary'),
        type:'primary'
    } as WheelButtonConfig),
    returnToWheel: () => ({
        action: WheelAction.NAVIGATE_TO_WHEEL,
        text: 'WHEEL.BUTTONS.NAVIGATE_TO_WHEEL',
        translateKeyValuePairs: {  },
        classes: wheelButtonTextClassMaker('secondary'),
        icon: 'assets/icons/return.svg',
        type: 'secondary'
    } as WheelButtonConfig),
    order: () => ({
        action: WheelAction.ORDER,
        text: 'WHEEL.BUTTONS.ORDER',
        translateKeyValuePairs: {  },
        classes: wheelButtonTextClassMaker('primary'),
        icon: 'assets/icons/cart-white.webp',
        type: 'primary'
    } as WheelButtonConfig),
        profile_order: (spins: number) => ({
        action: WheelAction.ORDER,
        text: 'WHEEL.BUTTONS.ORDER_TO_GET_SPINS',
        translateKeyValuePairs: { spins },
        classes: wheelButtonTextClassMaker('primary'),
        icon: 'assets/icons/cart-white.webp',
        type: 'primary'
    } as WheelButtonConfig)
}

export const mockSpinResponse = (type: 'bonuses' | 'product'):WheelGenericResponse<{ days: number; reward: WheelSegment }> => {
    return {
        success: true,
        data: {
            days: 365,
            reward:  type ==='bonuses' ? mockBonusReward : mockProductReward
        }
    }
}

const mockBonusReward: WheelSegment = {
    type: 'bonuses',
    position: 1,
    reward: {
        bonuses: '25.00',
        product: null,
        spins: null
    }
}

const mockProductReward: WheelSegment = {
    type: "product",
    position: 4,
    reward: {
        bonuses: null,
        product: {
            id: 1004,
            name: "Tokyo set",
            img: "https://storage.dev.3303.ua/assets/3303/crmimages/sets/tokyo-set.webp",
            category_img: "https://storage.dev.3303.ua/assets/3303/crmimages/sets/tokyo-set.webp",
            cat_id: 15
        },
        spins: null
    }
}

export const adaptBonusForDisplay = (data: { reward: WheelSegment, days: number }): WheelPrize => {
    const { reward, days } = data;
    switch (reward.type) {
        case 'bonuses':
            const normalizedReward = reward.reward as WheelBonusReward;
            const parsedBonuses = parseInt(normalizedReward.bonuses);
            return {
                type:reward.type,
                img: parsedBonuses === 0 ?'assets/wheel-of-fortune/sad-guy.png':'assets/cashback-guy.png',
                name: parsedBonuses,
                days
            }
        case 'product':
            const normalizedProductReward = reward.reward as WheelProductReward;
            return {
                type:reward.type,
                img: normalizedProductReward.product.img,
                name: normalizedProductReward.product.name,
                days    
            }
        case 'spins':
            const normalizedSpinReward = reward.reward as WheelSpinReward;
            return {
                type:reward.type,
                img: 'assets/wheel-of-fortune/trophy-spin.png',
                name: normalizedSpinReward.spins,
                days    
            }
    }
}

export const mockSegments:WheelSegment[] = [

  {
    "type": "bonuses",
    "position": 0,
    "reward": {
      "bonuses": "0.00",
        "product": null,
      "spins":null
    }
  },
  {
    "type": "bonuses",
    "position": 1,
    "reward": {
      "bonuses": "5.00",
        "product": null,
      "spins":null
    }
  },
  {
    "type": "bonuses",
    "position": 2,
    "reward": {
      "bonuses": "0.00",
        "product": null,
      "spins":null
    }
  },
  {
    "type": "bonuses",
    "position": 3,
    "reward": {
      "bonuses": "10.00",
        "product": null,
      "spins":null
    }
  },
  {
    "type": "product",
    "position": 4,
    "reward": {
      "bonuses": null,
      "product": {
        "id": 616,
        "name": "Суші Сяке",
        "img": "https://storage.dev.3303.ua/assets/3303/crmimages/sushi/syake.webp",
        "category_img": "https://storage.dev.3303.ua/assets/3303/crmimages/category_icon/i-sushi.png",
        "cat_id": 12
        },
      "spins":null
    }
  },
  {
    "type": "product",
    "position": 5,
    "reward": {
      "bonuses": null,
      "product": {
        "id": 470,
        "name": "Сяке рол",
        "img": "https://storage.dev.3303.ua/assets/3303/crmimages/rolls/syake.webp",
        "category_img": "https://storage.dev.3303.ua/assets/3303/crmimages/category_icon/i-roll.png",
        "cat_id": 3
        },
       "spins":null
    }
  },
  {
    "type": "product",
    "position": 6,
    "reward": {
      "bonuses": null,
      "product": {
        "id": 462,
        "name": "Філадельфія Класік",
        "img": "https://storage.dev.3303.ua/assets/3303/crmimages/rolls/filadelphia.webp?v=2",
        "category_img": "https://storage.dev.3303.ua/assets/3303/crmimages/category_icon/i-phila.png",
        "cat_id": 22
        },
       "spins":null
    }
  },
  {
    "type": "product",
    "position": 7,
    "reward": {
      "bonuses": null,
      "product": {
        "id": 1002,
        "name": "Філадельфія сет",
        "img": "https://storage.dev.3303.ua/assets/3303/crmimages/sets/phila-set-var1.webp",
        "category_img": "https://storage.dev.3303.ua/assets/3303/crmimages/category_icon/i-set.png",
        "cat_id": 15
        },
       "spins":null
    }
    },
    {
    "type": "spins",
    "position": 8,
    "reward": {
      "bonuses": null,
        "product": null,
      "spins":1
    }
    },
        {
    "type": "spins",
    "position": 9,
    "reward": {
      "bonuses": null,
        "product": null,
      "spins":1
    }
  },
]